
import React from 'react';
import { Table, Button } from 'react-bootstrap';
import FieldGroup from './common/FieldGroup.jsx';

export default class AppendCheckItemComponent extends React.Component {


    isPositiveDouble(input) {
        let re = new RegExp("^\\d+(\\.){0,1}\\d*$");
        return re.test(input);
    }

    onPriceChange(value) {
        if (this.isPositiveDouble(value)) {
            this.props.onPriceChange(value);
        } else {
            alert('價格必須為數字');
        }
    }

    render() {
        return (
            <div>
                <h4>{this.props.cat.description}&nbsp;:&nbsp;{this.props.checkSet.description}&nbsp;&nbsp;附加新選項</h4>
                <Table>
                    <tbody>
                        <tr>
                            <th>敘述</th>
                            <td>
                                <FieldGroup
                                    type="text"
                                    value={this.props.request.get('description')}
                                    onChange={(id, value) => {
                                        this.props.onDescriptionChange(value);
                                    }}
                                    maxLength='15'
                                />
                            </td>
                        </tr>
                        {/* <tr>
                            <th>價格</th>
                            <td>
                                <FieldGroup
                                    id="note"
                                    type="text"
                                    value={this.props.request.get('price')}
                                    onChange={(id, value) => {
                                        this.onPriceChange(value);
                                    }}
                                />
                            </td>
                        </tr> */}
                        <tr>
                            <th>附註</th>
                            <td>
                                <FieldGroup
                                    type="text"
                                    value={this.props.request.get('note')}
                                    onChange={(id, value) => {
                                        this.props.onNoteChange(value);
                                    }}
                                    maxLength='10'
                                />
                            </td>
                        </tr>
                        <tr>
                            <th colSpan='2' style={{ textAlign: 'right' }}><Button bsStyle="primary"
                                onClick={(event) => {
                                    this.props.onAppendCkItem(this.props.checkSet);
                                }} >建立清點項目</Button></th>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/AppendCheckItemComponent.jsx